import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { ApiClient, getGtcHubClientInstance } from 'src/client/apiClient';
import { OPT_IN_API_NAME } from 'src/constants/ApiConstants';
import { OptInRequest, OptInResponse } from 'src/types/OptIn';

export function useOptIn(
  componentName: string,
): UseMutationResult<OptInResponse, unknown, OptInRequest, unknown> {
  return useMutation<OptInResponse, unknown, OptInRequest>({
    mutationFn: (optInRequest: OptInRequest) => {
      const client: ApiClient = getGtcHubClientInstance();

      return client.client.request({
        url: `/optin/${encodeURIComponent(optInRequest.confirmationToken)}`,
        method: 'post',
        meta: {
          apiName: OPT_IN_API_NAME,
          component: componentName,
        },
      });
    },
  });
}
